import { DynamicContentType } from '../../types/content.types.js'
import { FileEntryBM } from '../../types/fileEntry.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export interface FoodMenuItem {
  title: string
  description: string
  uuid: string
  price: number
  category?: string
  image?: FileEntryBM
}

export interface FoodMenuData {
  items: FoodMenuItem[]
  marginBottom?: string
  marginTop?: string
}

export const foodMenu: DynamicContentType<FoodMenuData> = {
  name: 'foodMenu',
  viewName: 'Matmeny',
  featureKey: 'foodMenu',
  icon: LucideIconName.Utensils,
  uuid: '',
  data: {
    items: [],
  },
}
